/* tslint:disable */
/* eslint-disable */
export enum AuctionStateFilter {
  Active = 'active',
  Archived = 'archived',
  AcceptingPrebids = 'accepting_prebids'
}
